<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import BudgetProposalModal from "@/components/modals/budget-proposal-modal";
import Swal from "sweetalert2";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import ProposalModal from "@/components/modals/proposal-modal.vue";
import RemarksModal from "@/components/modals/remarks-modal.vue";
import FrontPage from "@/components/widgets/budget-proposal-front-page.vue";
import BackPage from "@/components/widgets/budget-proposal-back-page.vue";
import ReportParameters from "@/components/widgets/bp-report-parameters.vue";
import SummaryView from "@/components/widgets/budget-proposal-summary.vue";
import ApiLogs from "@/components/modals/api-logs.vue";
import LogModal from "@/components/modals/log-modal.vue";
import ApiAttachmentsModal from "@/components/modals/api-attachments-modal.vue";

export default {
    name: "BudgetCallWidget",
    props: {
        viewFrom: {
            type: String,
            default: "planning",
            validator: (val) => ["planning", "finance"].includes(val),
        },
    },
    components: {
        Layout,
        PageHeader,
        BudgetProposalModal,
        AttachmentModal,
        PrintOptions,
        ProposalModal,
        RemarksModal,
        FrontPage,
        BackPage,
        ReportParameters,
        SummaryView,
        ApiLogs,
        LogModal,
        ApiAttachmentsModal
    },
    data() {
        return {
            title: "Budget Call",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Budget Call",
                    active: true,
                },
            ],
            years: [],
            templates: [],
            selectedYear: null,
            viewPage: 'first',
            selectedTemplate: null,
            proposals: [],
            loadProposals: false,
            filterDUs: "",
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            budgets: [],
            modalTitle: "Proposal Details",
            sections: [],
            selectedProposalId: null,
            parentOPCR: null,
            selectedStatus: 1,
            postedProposals: [],
            approvedProposals: [],
            loadPage: false,
            returnData: null,
            viewingStatus: '',
            selectedTemplateId: null,
            selectedCampusId: null,
            selectedDuId: null,
            selectedProposal: null,
            selectedCampus: null,
            selectedDu: null,
            commentData: null,
            modalAction: '',
            formType: null,
            detailedSummary: false
        };
    },
    async mounted() {
        this.loadPage = true;
        await this.getTemplates();
        await this.getBudgets();
        await this.getSections();
        this.setTemplatesByYear(this.$store.state.data.cycle);
        if (this.$route.params.id) {
            let temp = this.templates.find(x => x.id == this.decryptUrl(this.$route.params.id));
            if (temp) {
                this.selectedTemplate = temp;
                this.viewProposal(temp);
            }
        }
        this.loadPage = false;
    },
    methods: {
        async getSections() {
            try {
                const { data: response } = await this.$store.dispatch("apisection/GetApiSections");
                if (response.error) {
                    return this.showToast(response.errorMessage, "error");
                }
                response.forEach(x => {
                    x.groups = JSON.parse(JSON.stringify(x.apiSectionGroups));
                    x.groupLoading = false;
                });
                this.sections = response;
            } catch (err) {
                this.showToast("Something went wrong!", "error");
            }
        },
        async getBudgets() {
            await this.$store
                .dispatch("accountgroups/getAllAccountGroup")
                .then((response) => {
                    if (response.error) {
                        return this.showToast(response.errorMessage, "error");
                    }
                    let expenses = response.data.filter(x => x.accountType?.toLowerCase().includes('expense'));
                    this.budgets = expenses;
                })
                .catch(() => {
                    this.showToast("Something went wrong. Cannot fetch available PREXCs", "error");
                });
        },
        async getTemplates() {
            try {
                const { data: response } = await this.$store.dispatch("budgetproposaltemplate/GetAllBudgetProposalTemplates");
                if (response.error) {
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.templates = response;
            } catch (error) {
                this.showToast("Error fetching templates", "error");
            }
        },
        setTemplatesByYear(currentCycle) {
            this.years = [];
            const currentYear = JSON.parse(currentCycle);
            for (let i = currentYear; i <= currentYear + 2; i++) {
                this.years.push({
                    year: i,
                    templates: this.templates.filter(template => template.cycle == i),
                });
            }
        },
        recreateYears() {
            this.years = this.years.map(yearObj => {
                return {
                    ...yearObj,
                    templates: this.templates.filter(template => template.cycle == yearObj.year),
                };
            });
        },
        createTemplate(year) {
            this.selectedYear = year;
            this.$bvModal.show("budget-proposal-modal");
            this.$refs.bpModal.resetForm();
        },
        async submitTemplate(modalData) {
            modalData.cycle = this.selectedYear;
            if (modalData.id == 0) {
                try {
                    const { data: response } = await this.$store.dispatch("budgetproposaltemplate/CreateBudgetProposalTemplate", modalData);
                    if (response.error) {
                        this.showToast(response.errorMessage, "error");
                        return;
                    }
                    this.templates.push(response);
                    this.recreateYears();
                    this.showToast("Budget Call created successfully", "success");
                    this.$bvModal.hide("budget-proposal-modal");
                } catch (error) {
                    this.showToast("Error updating template", "error");
                }
            } else {
                try {
                    const { data: response } = await this.$store.dispatch("budgetproposaltemplate/UpdateBudgetProposalTemplate", modalData);
                    if (response.error) {
                        this.showToast(response.errorMessage, "error");
                        return;
                    }
                    let index = this.templates.findIndex(x => x.id == modalData.id);
                    if (index !== -1) {
                        this.templates.splice(index, 1, modalData);
                    }
                    this.recreateYears();
                    this.showToast("Budget Call updated successfully", "success");
                    this.$bvModal.hide("budget-proposal-modal");
                } catch (error) {
                    this.showToast("Error updating template", "error");
                }
            }
        },
        editTemplate(template) {
            this.selectedYear = template.cycle;
            this.$bvModal.show("budget-proposal-modal");
            this.$refs.bpModal.updateData(template);
        },
        deleteTemplate(template) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const { data: response } = await this.$store.dispatch("budgetproposaltemplate/RemoveBudgetProposalTemplate", template.id);
                        if (response.error) {
                            this.showToast(response.errorMessage, "error");
                            return;
                        }
                        let index = this.templates.findIndex(x => x.id == template.id);
                        if (index !== -1) {
                            this.templates.splice(index, 1);
                        }
                        this.recreateYears();
                        this.showToast("Budget Call deleted successfully", "success");
                    } catch (error) {
                        this.showToast("Error deleting template", "error");
                    }
                }
            });
        },
        async viewProposal(temp) {
            this.viewPage = 'second';
            this.selectedTemplate = temp;
            const newUrl = `/${this.viewFrom}/budget-call/${this.encryptUrl(
                temp.id
            )}`;
            window.history.pushState({ path: newUrl }, "", newUrl);
        },
        backToFrontPage() {
            this.viewPage = 'first';
            this.selectedTemplate = null;
            const newUrl = `/${this.viewFrom}/budget-call`;
            window.history.pushState({ path: newUrl }, "", newUrl);
        },
        async viewResources(api) {
            api.showResources = !api.showResources;
            if (api.showResources && !api.resources.length) {
                api.itemLoading = true;
                await this.getResourceDetails(api);
                api.itemLoading = false;
            }
        },
        async getResourceDetails(api) {
            try {
                const { data: response } = await this.$store.dispatch("planningapiresource/GetPlanningApiResourcesByApi", api.id);
                if (response.error) {
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.forEach((item) => {
                    let budgetInfo = this.budgets.find((x) => x.id == item.accountGroupId);
                    item.totalQuantity = item.planningApiResourceDetails.reduce((pv, cv) => {
                        return (parseFloat(pv) + parseFloat(cv.quantity));
                    }, 0);
                    item.financeTemplateBudgetItem = {
                        fundSource: budgetInfo?.fundSource || "",
                        fundClass: budgetInfo?.fundClassification?.classification || "",
                        fundClassification: budgetInfo?.fundClassification || null,
                        groupName: budgetInfo?.groupName || "",
                        accountGroup: budgetInfo?.groupName || "",
                        accountId: budgetInfo?.id || item.accountGroupId,
                        id: budgetInfo?.id || item.accountGroupId
                    };
                    item.showRow = true;
                    item.showChild = true;
                    item.filterKey = `${item.itemName} ${item.description}`;
                    item.status = null;
                });
                api.resources = response;
            } catch (err) {
                this.showToast("Error fetching resources", "error");
                return;
            }
        },
        filteredItems(items, filter) {
            let data = items;
            if (filter && filter.trim() !== '') {
                data = data.filter(x => {
                    return x.filterKey.toUpperCase().includes(filter.toUpperCase());
                })
            }
            return data;
        },
        async showApiAttachments(api) {
            this.$bvModal.show("upload-attachment-modal");
            this.$refs.attachmentModal.setUploadOpt({
                type: "API Special Projects",
                placement: "left",
                folder: "Office",
            });
            await this.$refs.attachmentModal.getData(api.id);
        },
        printForm2({ templateId, campusId, status = null }) {
            this.formType = 'form2'
            this.selectedTemplateId = templateId;
            this.selectedCampusId = campusId;
            this.$refs.reportParameters.resetForm(status);
            this.$bvModal.show("bp-report-parameters-modal");
        },
        printForm5({ templateId, campusId }) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/BudgetProposal/Form5/Tier1",
                routeVariables: [templateId, campusId],
            });
            this.$bvModal.show("print-options-modal");
        },
        printForm7({ templateId, campusId }) {
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Planning/BudgetProposal/Form7/Tier2",
                routeVariables: [templateId, campusId],
            });
            this.$bvModal.show("print-options-modal");
        },
        printForm8({ templateId, campusId, duId, status, summary = false, detailed = false }) {
            this.formType = 'form8'
            this.selectedTemplateId = templateId;
            this.selectedCampusId = campusId;
            this.selectedDuId = duId;
            this.detailedSummary = detailed;
            this.$refs.reportParameters.resetForm(status, summary);
            this.$bvModal.show("bp-report-parameters-modal");
        },
        printOverallSummary(templateId) {
            this.formType = 'overall'
            this.selectedTemplateId = templateId;
            this.$refs.reportParameters.resetForm(null, true);
            this.$bvModal.show("bp-report-parameters-modal");
        },
        printDBMForm8({ templateId, campusId }) {
            this.$refs.printOpt.putOptions({
                apiUrl: campusId ? 'api/Report/Planning/BudgetProposal/DBM/Form8/CampusBudgetSummary' : 'api/Report/Planning/BudgetProposal/DBM/Form8/SystemBudgetSummary',
                routeVariables: campusId ? [templateId, campusId] : [templateId],
            });
            this.$bvModal.show("print-options-modal");
        },
        submitParams(body) {
            let routeVar = [];
            let apiUrl = "";
            if (this.formType == 'form8') {
                if (this.selectedCampusId) {
                    routeVar.push(this.selectedCampusId);
                    apiUrl = "api/Report/Planning/BudgetProposal/Campus";
                    routeVar.push(this.selectedTemplateId);
                } else if (this.selectedDuId) {
                    routeVar.push(this.selectedDuId);
                    if (body.summary) {
                        routeVar.push(this.selectedTemplateId);
                        apiUrl = this.detailedSummary ? 'api/Report/Planning/BudgetProposal/DeliveryUnit/Summary/Detailed' : 'api/Report/Planning/BudgetProposal/DeliveryUnit/Summary'
                        routeVar.push(body.status)
                    } else {
                        apiUrl = 'api/Report/Planning/BudgetProposal/DeliveryUnit'
                        routeVar.push(this.selectedTemplateId);
                    }
                } else {
                    apiUrl = "api/Report/Planning/BudgetProposal/System";
                    routeVar.push(this.selectedTemplateId);
                }
            } else if (this.formType == 'form2') {
                if (this.selectedCampusId) {
                    routeVar.push(this.selectedCampusId);
                    apiUrl = "api/Report/Planning/BudgetProposal/RDC/Form2/Campus";
                } else {
                    apiUrl = "api/Report/Planning/BudgetProposal/RDC/Form2/System";
                }
                routeVar.push(this.selectedTemplateId);
            } else {
                apiUrl = "api/Report/Planning/BudgetProposal/System/Summary";
                routeVar = [this.selectedTemplateId, body.status];
            }
            this.$refs.printOpt.putOptions({
                apiUrl: apiUrl,
                routeVariables: routeVar,
                body: body,
            });
            this.$bvModal.show("print-options-modal");
        },
        viewProposalData({ props, status, campus, du }) {
            this.viewingStatus = status;
            this.selectedProposal = props;
            this.selectedDu = du;
            this.selectedCampus = campus;
            this.modalTitle = `${props.name} - Proposal Details`;
            this.$refs.proposalModal.updateForm(props, campus, du);
            this.$bvModal.show("proposal-modal");
        },
        approveProposal({ proposalId, du, campus }) {
            this.$swal({
                title: "Are you sure?",
                text: "You are about to approve this proposal.",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, approve proposal!"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data: response } = await this.$store.dispatch("planningapi/ApprovePlanning", proposalId);
                        if (response?.error) {
                            this.showToast(response.errorMessage, "error");
                            return;
                        }
                        this.$bvModal.hide("proposal-modal");
                        this.showToast("Proposal approved successfully", "success");
                        let apiIndex = du.proposals.findIndex(x => x.id == proposalId);
                        if (apiIndex !== -1) {
                            du.proposals.splice(apiIndex, 1);
                            if (du.proposals.length == 0) {
                                campus.dus.splice(campus.dus.findIndex(x => x.id == du.id), 1);
                            }
                        }
                    } catch (err) {
                        this.showToast("Error approving proposal", "error");
                    }
                }
            });
        },
        returnProposal(data) {
            this.modalAction = 'return';
            this.returnData = data;
            this.$refs.remarksModal.open({
                title: "Return Remarks",
                label: "Remarks",
                placeholder: "Enter Remarks...",
                btnText: "Return",
                btnClass: "btn-warning",
                btnIcon: "bx bx-reply",
                data: { ...data, action: 'return' }
            });
        },
        addComment(data) {
            this.modalAction = 'comment';
            this.commentData = data;
            const proposalName = data.proposal?.name || data.name || '';
            this.$refs.remarksModal.open({
                title: proposalName ? `Add Comment - ${proposalName}` : "Add Comment",
                label: "Comment",
                placeholder: "Enter Comment...",
                btnText: "Submit Comment",
                btnClass: "btn-info",
                btnIcon: "bx bx-comment-dots",
                data: { ...data, action: 'comment' }
            });
        },
        parkProposal({ proposalId, du, campus }) {
            this.$swal({
                title: "Are you sure?",
                text: "You are about to park this proposal.",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, park proposal!"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data: response } = await this.$store.dispatch("planningapi/AddToParkList", [proposalId]);
                        if (response?.error) {
                            this.showToast(response.errorMessage, "error");
                            return;
                        }
                        this.$bvModal.hide("proposal-modal");
                        this.showToast("Proposal parked successfully", "success");
                        let apiIndex = du.proposals.findIndex(x => x.id == proposalId);
                        if (apiIndex !== -1) {
                            du.proposals.splice(apiIndex, 1);
                            if (du.proposals.length == 0) {
                                campus.dus.splice(campus.dus.findIndex(x => x.id == du.id), 1);
                            }
                        }
                    } catch (err) {
                        this.showToast("Error parking proposal", "error");
                    }
                }
            });
        },
        shortlistProposal({ proposalId, du, campus }) {
            this.$swal({
                title: "Are you sure?",
                text: "You are about to shortlist this proposal.",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, shortlist proposal!"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data: response } = await this.$store.dispatch("planningapi/AddToShortList", [proposalId]);
                        if (response?.error) {
                            this.showToast(response.errorMessage, "error");
                            return;
                        }
                        this.$bvModal.hide("proposal-modal");
                        this.showToast("Proposal shortlisted successfully", "success");
                        let apiIndex = du.proposals.findIndex(x => x.id == proposalId);
                        if (apiIndex !== -1) {
                            du.proposals.splice(apiIndex, 1);
                            if (du.proposals.length == 0) {
                                campus.dus.splice(campus.dus.findIndex(x => x.id == du.id), 1);
                            }
                        }
                    } catch (err) {
                        this.showToast("Error shortlisting proposal", "error");
                    }
                }
            });
        },
        async submitRemarks(remarks, customData) {
            const action = customData?.action || this.modalAction || 'return';
            if (action === 'comment') {
                const targetData = customData || this.commentData;
                const proposalId = targetData?.proposalId || targetData?.proposal?.id || targetData?.id;
                try {
                    const { data: response } = await this.$store.dispatch("planningapi/AddComment", {
                        id: proposalId,
                        remarks: remarks,
                        comment: remarks,
                    });
                    if (response?.error) {
                        this.showToast(response.errorMessage, "error");
                        return;
                    }
                    this.$bvModal.hide("remarks-modal");
                    this.showToast("Comment added successfully", "success");
                } catch (err) {
                    this.showToast("Error adding comment", "error");
                }
                return;
            }

            const returnInfo = customData || this.returnData;
            const proposalId = returnInfo?.proposalId || returnInfo?.id;
            try {
                const { data: response } = await this.$store.dispatch("planningapi/ReturnApi", {
                    id: proposalId,
                    remarks: remarks
                });
                if (response?.error) {
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.$bvModal.hide("proposal-modal");
                this.showToast("Proposal returned successfully", "success");
                this.$bvModal.hide("remarks-modal");
                const du = returnInfo?.du;
                if (du && du.proposals) {
                    let apiIndex = du.proposals.findIndex(x => x.id == proposalId);
                    if (apiIndex !== -1) {
                        du.proposals.splice(apiIndex, 1);
                        if (du.proposals.length == 0 && returnInfo?.campus && returnInfo.campus.dus) {
                            returnInfo.campus.dus.splice(returnInfo.campus.dus.findIndex(x => x.id == du.id), 1);
                        }
                    }
                }
            } catch (err) {
                this.showToast("Error returning proposal", "error");
            }
        },
        viewSummary(proposal) {
            this.viewPage = 'third';
        },
        backToSecondPage() {
            this.viewPage = 'second';
        },
        async uploadAttachments(data) {
            try {
                let response = await this.$store.dispatch("filemanager/UploadFile", data);
                if (response.data.error) {
                    return { error: true, message: response.data.errorMessage };
                }
                return { error: false, data: response.data };
            } catch (e) {
                return { error: true, message: "Something went wrong" };
            }
        },
        async uploadFiles(files, id) {
            let errors = 0;
            for await (const file of files) {
                let data = {
                    type: "API Special Projects",
                    folder: "Office",
                    file: file.file,
                    description: file.description,
                    removeLoading: true,
                    id: id,
                };
                let response = await this.uploadAttachments(data);
                if (response.error) {
                    errors++;
                }
            }
            if (errors > 0) {
                this.showToast("Some files cannot be uploaded!", "error");
            }
        },
        submitProposal(modalData) {
            let data = JSON.parse(JSON.stringify(modalData));
            delete data.uploadFiles;
            delete data.du;
            delete data.campus;
            if (data.id > 0) {
                this.$store
                    .dispatch("planningapi/UpdatePlanningApi", data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.$bvModal.hide("proposal-modal");
                        this.showToast("Successfully updated!", "success");
                        if (modalData.uploadFiles && modalData.uploadFiles.length) {
                            this.uploadFiles(modalData.uploadFiles, data.id);
                        }

                        // Update the specific proposal row
                        const du = modalData.du || this.selectedDu;
                        if (du && du.proposals) {
                            let index = du.proposals.findIndex(x => x.id == data.id);
                            if (index !== -1) {
                                let existing = du.proposals[index];
                                let updatedProposal = {
                                    ...existing,
                                    name: data.name,
                                    description: data.description,
                                    expectedOutput: data.expectedOutput,
                                    apiTypeId: data.apiTypeId,
                                    status: data.status,
                                    preOPCRId: data.preOPCRId,
                                    planningTargetId: data.planningTargetId,
                                };
                                du.proposals.splice(index, 1, updatedProposal);
                            }
                        }
                        if (this.selectedProposal && this.selectedProposal.id == data.id) {
                            this.$set(this.selectedProposal, 'name', data.name);
                            this.$set(this.selectedProposal, 'description', data.description);
                        }
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
        },
        showApiLogs(api) {
            this.$bvModal.show('api-log-modal');
            this.modalTitle = `${api.name} Logs`
            this.$refs.apiLogs.getData(api.id, true);
        },
        async viewBCLogs(item) {
            this.modalTitle = item?.description ? `${item.description} Logs` : "Budget Call Logs";
            this.$bvModal.show("log-modal");
            let logs = item?.logs;
            if (!logs && item?.id) {
                try {
                    const { data: res } = await this.$store.dispatch("budgetproposaltemplate/GetSingleBudgetProposalTemplate", item.id);
                    if (res && res.logs) {
                        logs = res.logs;
                    }
                } catch (e) {
                    console.error("Error fetching budget call logs:", e);
                }
            }
            this.$refs.logModal.setLogs(logs || item, this.modalTitle);
        },
        viewAllAttachments(apis) {
            if (apis?.length == 0) {
                this.showToast("No apis found!", "error");
                return;
            }
            this.$refs.apiAttachmentsModal.getAttachments(apis)
        }
    },
}
</script>
<template>
    <Layout @changeCycle="setTemplatesByYear($event)">
        <PageHeader :title="title" :items="items" />
        <template v-if="loadPage">
            <div class="d-flex align-items-center justify-content-center" style="height: 450px;">
                <b-spinner label="Loading..."></b-spinner>
            </div>
        </template>
        <template v-else>
            <template v-if="viewPage == 'first'">
                <FrontPage :years="years" @create-template="createTemplate" @edit-template="editTemplate"
                    @delete-template="deleteTemplate" @view-proposal="viewProposal" @print-form2="printForm2"
                    @print-form5="printForm5" @print-form7="printForm7" @print-form8="printForm8"
                    @view-logs="viewBCLogs" />
            </template>
            <template v-if="viewPage == 'second'">
                <BackPage ref="secondPage" :selectedTemplate="selectedTemplate" :proposals="proposals"
                    :budgets="budgets" :viewFrom="viewFrom" @back="backToFrontPage" @print-form8="printForm8"
                    @print-form2="printForm2" @print-form5="printForm5" @print-form7="printForm7"
                    @view-resources="viewResources" @show-api-attachments="showApiAttachments"
                    @view-proposal-data="viewProposalData" @approve-proposal="approveProposal"
                    @return-proposal="returnProposal" @park-proposal="parkProposal"
                    @shortlist-proposal="shortlistProposal" @view-summary="viewSummary" @add-comment="addComment"
                    @show-api-logs="showApiLogs" @view-attachments="viewAllAttachments"
                    @print-overall-summary="printOverallSummary" @print-dbm-form8="printDBMForm8" />
            </template>
            <template v-if="viewPage === 'third'">
                <SummaryView :selectedTemplate="selectedTemplate" @back="backToSecondPage" />
            </template>
        </template>
        <BudgetProposalModal ref="bpModal" @submit="submitTemplate" />
        <LogModal ref="logModal" :modalTitle="modalTitle" />
        <attachment-modal :wActions="false" title="API Attachments" ref="attachmentModal"></attachment-modal>
        <print-options ref="printOpt"></print-options>
        <ProposalModal ref="proposalModal" :modalTitle="modalTitle" :sections="sections" :viewingStatus="viewingStatus"
            :viewFromPME="true" @approve="approveProposal" @return="returnProposal" @shortlist="shortlistProposal"
            @park="parkProposal" @submit="submitProposal" />
        <RemarksModal ref="remarksModal" @submit="submitRemarks" />
        <ReportParameters ref="reportParameters" @submit="submitParams" />
        <ApiLogs ref="apiLogs" :modalTitle="modalTitle" />
        <ApiAttachmentsModal ref="apiAttachmentsModal" />
    </Layout>
</template>
